

import React, {Component} from 'react';
import {Button, Transfer, Tree} from 'antd';
import * as Actions from "../../../actions/allResources";
const { TreeNode } = Tree;

// Customize Table Transfer
const isChecked = (selectedKeys, eventKey) => {
    return selectedKeys.indexOf(eventKey) !== -1;
};
const generateTree = (treeNodes = [], checkedKeys = []) => {
    return treeNodes.map((item) => {
        let { children, ...props } = item;
        return (
            <TreeNode {...props} style={{display:props.display?props.display:'block'}} disabled={checkedKeys.includes(props.key)} key={props.key} checkable={item.checkedable!==false}>
                {generateTree(children, checkedKeys)}
            </TreeNode>
        )
    });
};
const TreeTransfer = ({ dataSource, targetKeys, ...restProps }) => {
    const transferDataSource = [];
    function flatten(list = []) {
        list.forEach(item => {
            item.name = item.title;
            transferDataSource.push(item);
            flatten(item.children);
        });
    }
    flatten(dataSource);

    let renderSon = (params) => {
        let { direction, onItemSelect, selectedKeys } = params;

        if (direction === 'left') {
            const checkedKeys = [...selectedKeys, ...targetKeys];
            return (
                <Tree
                    blockNode
                    checkable
                    checkStrictly
                    defaultExpandAll
                    checkedKeys={checkedKeys}

                    onCheck={(
                        _,
                        {
                            node: {
                                props: { eventKey },
                            },
                        },
                    ) => {
                        onItemSelect(eventKey, !isChecked(checkedKeys, eventKey));
                    }}
                    onSelect={(
                        _,
                        {
                            node: {
                                props: { eventKey },
                            },
                        },
                    ) => {
                        onItemSelect(eventKey, !isChecked(checkedKeys, eventKey));
                    }}
                >
                    {generateTree(dataSource, targetKeys)}
                </Tree>
            );
        }
    };
    return (
        <Transfer
            {...restProps}
            targetKeys={targetKeys}
            dataSource={transferDataSource}
            className="tree-transfer"
            showSearch
            render={item => item.name}
            showSelectAll={false}
            onSearch={restProps.handleSearch}
        >

            {
                renderSon
            }
        </Transfer>
    );

};



export class User extends Component {
    constructor(props) {
        super(props);
        this.state = {
            treeData:[],//树的数据源
            targetKeys:[],// 选中的数据

        };
    }
    componentDidMount() {
        this.getDeptUserAll();
    }

    getDeptUserAll(){
        this.state.targetKeys =[];

        let addKey = (item)=>{
            item.key = item.id;
            item.checkedable = item.checkType.indexOf("dept")===-1;
            item.children && item.children.map(child=>addKey(child));
        };

        Actions.deptUserAll( (data) => {
            console.log(data,'data')
            data.forEach((item,index)=>{
                addKey(item);
            });
            this.setState({treeData:data})
        });

    }

    render() {
        return(
            <div id={'classification'}>
                <TreeTransfer dataSource={this.state.treeData}  targetKeys={this.state.targetKeys} onChange={this.TransferChange}  onSelectChange={()=>{}} handleSearch={this.handleSearch}/>
                <style>{
                    ` 
                     #classification .ant-transfer-list-body-customize-wrapper{
                       height:380px
                    }   
                      #classification .ant-transfer-list-body-customize-wrapper{
                       overflow-y: auto;
                    }        
                     #classification .ant-transfer-list-content  {
                      height:420px
                     }  
                       #classification .tree-transfer{height:480px}   
                     #classification div:nth-child(3) .ant-transfer-list-body-search-wrapper{
                     display:none
                     }     
                    `
                }</style>
            </div>
        )
    }
    TransferChange = (targetKeys, direction, moveKeys)=>{
        targetKeys = targetKeys.filter((item,index)=>{
            return item.indexOf("dept")===-1;
        });
        this.props.callbackUserData&&this.props.callbackUserData(targetKeys)
        this.setState({targetKeys});

    };
    handleSearch = (dir, value) => {
       let dataArray = this.state.treeData;
        dataArray.forEach((item,index)=>{
            item.children.forEach((items,i)=>{
                if(items.name.indexOf(value)>-1){
                     items.display ='block'
                }else{
                    items.display ='none'
                }
            });
            this.setState({treeData:dataArray})

        })

    };
    handleCancel = e => {
        this.setState({share: false});
    };

    onSelectChange =(e)=>{
        // let key = e.toString().replace(/[^0-9]/g, "");
        // this.state.treeData.forEach((item,index)=>{
        //     if(item.id.toString() === key){
        //         Actions.userList( 1,-1,key,(data) => {
        //             data.data && data.data.map(user=>{
        //                 user.key = "user"+user.id;
        //             });
        //             this.state.treeData[index].children = data.data;
        //             this.setState({})
        //         })
        //     }
        // })
    }
}



